<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-14 09:17:49
 * @LastEditTime: 2020-10-27 09:46:03
 * @Description: 新增编辑销售订单抽屉
-->
<template>
  <Drawer width="800" :title="`${openedSalesOrder ? '编辑' : '新增'}销售订单`" v-model="drawerOpened">
    <Modal width="800" v-model="isShowchooseRecipeModal" footer-hide>
      <div class="table-wrapper" ref="tableWrapper">
        <div class="handle-wrapper">
          <div class="handle-left">
            当前配方：{{ '#' + selectItem?.recipe.NoId || "无" }}
          </div>
          <div class="handle-right">
            <span>共{{ recipetotalRows }}条</span>
            <Page :total="recipetotalRows" :page-size="15" @on-change="loadRecipe" show-total simple
              style="margin-right: 24px" />
          </div>
        </div>
        <Table :columns="columns" :data="recipeSalesList" :height="tableHeight"> </Table>
      </div>
    </Modal>
    <div class="drawer-content">
      <Form style="height: 100%;" @submit.native.prevent ref="formItem" :model="formItem" :rules="ruleValidate" label-por5sition="top">
        <div class="form-item-wrap">
          <div class="form-item-left" style="width: 320px">
            <h2>订单列表</h2>

            <div v-if="soList.length === 0">
              请在下列销售项目中选择
            </div>
            <div class="sales-order-box" v-for="(so, index) in soList" :key="index">
              <div class="del-icon">
                <Icon type="ios-close" size="24" @click="delSOList(index)" />
              </div>

              <div>
                <h3>{{ so.sales.abbr }}</h3>
                <div @click="openChooseRecipe('create', so, index)" class="so-recipe-row">
                  <h4 style="margin-right: 12px;">配方：</h4>
                  <div v-if="so.recipe" class="recipe">
                    {{ '#' + so.recipe.NoId + '（' + so.recipe.name + '）' }}
                  </div>
                  <div v-else class="recipe">

                  </div>
                </div>

                <FormItem label="数量：" prop="volPlan">
                  <InputNumber v-model="so.volPlan" />
                  吨
                </FormItem>
                <div class="option-cell-list" style="width: 100%; margin-top: 20px; height: 30px">
                  <div v-for="(d, tonIndex) in tonOption" :key="tonIndex" @click="tonClick(d.tonValue, index)" :class="{
                    'option-cell': true,
                    selected: d.tonValue === so.volPlan,
                  }">
                    {{ d.name }}
                  </div>
                </div>
              </div>
            </div>

            <Divider v-if="!editMode" />
            <Input v-if="!editMode" v-model="searchText" search clearable placeholder="搜索销售项目..."
              @on-change="getRecommendSalesOrderMethod" icon="ios-search">
            </Input>

            <div v-if="!editMode">
              <Row style="margin-top: 4px; padding: 4px 0; border-bottom: 1px solid #ececec;">
                <Col span="3">
                评审
                </Col>
                <Col span="3">
                审单
                </Col>
                <Col span="3">
                限供
                </Col>
                <Col span="15">
                销售项目
                </Col>
              </Row>
              <div v-for="so in soRecommendList" @click="selectSales(so)">
                <Row class="sales-row">
                  <Col span="3">
                  <Icon v-if="so.allowSales" type="md-checkmark" size="24" color="lightgreen" />
                  <Icon v-else type="md-close" size="24" color="pink" />
                  </Col>
                  <Col span="3">
                  {{ so.prePaidOnly ? '需要' : '-' }}
                  </Col>
                  <Col span="3">
                  {{ so.isLimitVolPerMonth ? so.limitVolPerMonth : '-' }}
                  </Col>
                  <Col span="15">
                  {{ so.abbr }}
                  </Col>
                </Row>
              </div>
            </div>

          </div>
          <div class="form-item-right" style="width: 420px">
            <FormItem label="抵达时间">
              <div style="width: 180px; margin-bottom: 20px; float: left">
                <FormItem prop="arrivedAtDate">
                  <DatePicker v-model="formItem.arrivedAtDate" type="date" style="width: 150px; margin-right: 16px"
                    placeholder="选择日期"></DatePicker>
                </FormItem>
              </div>
              <div style="width: 150px; margin-bottom: 20px; float: left">
                <FormItem prop="arrivedAtTime">
                  <TimePicker format="HH:mm" style="width: 112px" v-model="formItem.arrivedAtTime" placeholder="选择时间">
                  </TimePicker>
                </FormItem>
              </div>

              <div class="option-cell-list" style="width: 100%; margin-top: 20px">
                <div v-for="(d, index) in dateOption" :key="index" @click="dateClick(d.addDates)" :class="{
                  'option-cell': true,
                  selected: d.addDates === dateOptionValue,
                }">
                  {{ d.name }}
                </div>
              </div>

              <div class="option-cell-list">
                <div v-for="(t, index) in timeOption" :key="index" :class="{
                  'option-cell': true,
                  selected: t.time === formItem.arrivedAtTime,
                }" @click="timeClick(t)">
                  {{ t.time }}
                </div>
              </div>
            </FormItem>

            <FormItem label="车俩"> </FormItem>
            <div class="vehicle-cell-list">
              <div v-for="(c, index) in vehicleDisplayList" :key="c._id" :class="{
                'vehicle-option-cell': true,
                selected: c._id === formItem.delivery.vehicle,
              }" @click="vehicleClick(c, 'vehicle')">
                {{ c.plate }}
              </div>
              <div v-if="!showAllVehicle" class="tool-btn" @click="showAllVehicle = true">显示全部</div>
              <div v-else class="tool-btn" @click="showAllVehicle = false">隐藏多余</div>
            </div>
            <FormItem label="司机"></FormItem>
            <div class="vehicle-cell-list">
              <div v-for="(c, index) in userList" :key="c._id" :class="{
                'vehicle-option-cell': true,
                selected: c._id === formItem.delivery.driver,
              }" @click="vehicleClick(c, 'driver')">
                {{ c.name }}
              </div>
            </div>

            <FormItem label="备注" prop="remark">
              <Input type="text" v-model="formItem.remark" placeholder="请输入备注" />
            </FormItem>
          </div>
        </div>

      </Form>
    </div>
    <div class="footer">
      <Button type="primary" style="width: 150px; margin-left: 12px" @click="handleSubmit('formItem')">保存</Button>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import dayjs from "dayjs";
import loadMore from '@/directives/loadMore'
import { Divider } from "view-design";
import { omit } from 'lodash'

const statusToText = {
  created: "未接单",
  verified: "合格",
  reviewing: "待验收",
  rejected: "不合格",
  canceled: "已取消",
};
export default {
  name: "AddSalesOrderDrawer",
  directives: {
    loadMore,
  },
  data() {
    return {
      salesProd: null,
      page: 0,
      editMode: false,
      openedSalesOrder: null,
      drawerOpened: false,
      openedSac: null,
      customerLoading: false,
      searchText: null,
      soRecommendList: [],
      formItem: {
        factory: null,
        arrivedAtTime: null,
        arrivedAtDate: null,
        remark: null,
        delivery: { driver: null, vehicle: null },
      },
      ruleValidate: {
        // volPlan: [
        //   {
        //     type: "number",
        //     required: true,
        //     message: "数量为必填项",
        //     trigger: "blur",
        //   },
        // ],
        arrivedAtDate: [
          {
            required: true,
            type: "date",
            message: "日期为必填项",
            trigger: "change",
          },
        ],
        arrivedAtTime: [
          {
            required: true,
            type: "string",
            message: "时间为必填项",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            type: "string",
            message: "公司为必选项",
            trigger: "change",
          },
        ],
      },
      timeOption: [
        { ampm: "am", time: "05:00" },
        { ampm: "am", time: "06:00" },
        { ampm: "am", time: "07:00" },
        { ampm: "am", time: "08:00" },
        { ampm: "am", time: "09:00" },
        { ampm: "am", time: "10:00" },
        { ampm: "am", time: "11:00" },
        { ampm: "pm", time: "12:00" },
        { ampm: "pm", time: "13:00" },
        { ampm: "pm", time: "14:00" },
        { ampm: "pm", time: "15:00" },
        { ampm: "pm", time: "16:00" },
        { ampm: "pm", time: "17:00" },
        { ampm: "pm", time: "18:00" },
        { ampm: "pm", time: "19:00" },
        { ampm: "pm", time: "20:00" },
        { ampm: "pm", time: "21:00" },
      ],
      dateOption: [
        { name: "今天", addDates: 0 },
        { name: "明天", addDates: 1 },
        { name: "后天", addDates: 2 },
      ],
      tonOption: [
        { name: "11吨", tonValue: 11 },
        { name: "15吨", tonValue: 15 },
        { name: "20吨", tonValue: 20 },
        { name: "30吨", tonValue: 30 },
      ],
      soList: [],
      isShowchooseRecipeModal: false,
      filterQuery: {},
      page: 0,
      salesPage: 0,
      salesLimit: 20,
      isSurplus: true,
      salesList: [],
      searchSales: null,
      tableLoading: false,
      tableHeight: 500,
      limit: 20,
      selectItem: null,
      selectItemSales: null,
      selectItemIndex: null,
      prodRecipe: null,
      columns: [
        {
          title: "生产配方",
          key: "createdBy",
          align: "center",
          minWidth: 80,
          maxWidth: 80,
          render: (h, params) => {
            return h("div", [
              h("div", params.row._id === this.selectItem?.recipe?._id ? "当前使用" : ""),
            ]);
          },
        },
        {
          title: "NoId",
          key: "NoId",
          align: "right",
          width: 100,
          render: (h, params) => {
            return h("strong", "#" + params.row.NoId);
          },
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          width: 100,
          render: (h, params) => h('div', params.row.createdBy?.name),
        },
        {
          title: "创建时间",
          key: "createdAt",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h("div", dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")),
            ]);
          },
        },
        {
          title: "配方",
          key: "recipe",
          width: 100,
          render: (h, params) => h("div", params.row.name)
        },
        {
          title: "审核",
          key: "status",
          align: "center",
          render: (h, params) => {
            return h("div", [h("div", statusToText[params.row.status])]);
          },
        },
        {
          title: "选择配方",
          key: "recipe",
          render: (h, params) => {
            return h("div", {
              style: {
                cursor: "pointer",
                color: "#42b983",
              },
              on: {
                click: () => {
                  this.chooseRecipe(params.row);
                },
              },
            }, "选择");
          },
        },
      ],
      showAllVehicle: false,
    };
  },
  computed: {
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
      vehicleList: (state) => state.vehicle.vehicleList,
      totalRows: (state) => state.sales.totalCounts,
      recipeSalesList: (state) => state.recipeSales.recipeSalesList,
      companyList: (state) => state.company.companyList,
      userList: (state) => state.user.simpleUserList,
      recipetotalRows: (state) => state.recipeSales.totalCounts,
    }),
    ...mapGetters({
      salesById: "sales/salesById",
    }),
    dateOptionValue: function () {
      if (this.formItem.arrivedAtDate === null)
        return;
      return (dayjs(this.formItem.arrivedAtDate).get("date") - dayjs().get("date"));
    },
    vehicleDisplayList: function () {
      if (this.showAllVehicle || !this.formItem.factory) {
        return this.vehicleList;
      } else {
        const factoryVehicleList = this.vehicleList.filter(v => v.factory.map(x => x._id).includes(this.formItem.factory));
        if (!this.formItem.delivery.vehicle) return factoryVehicleList;
        if (factoryVehicleList.map(v => v._id).includes(this.formItem.delivery.vehicle)) {
          return factoryVehicleList;
        } else {
          const selectedVehicle = this.vehicleList.find(v => v._id === this.formItem.delivery.vehicle)
          return [selectedVehicle, ...factoryVehicleList];
        }
      }
    },
  },
  methods: {
    ...mapActions({
      createSalesOrdMultier: "salesOrder/createSalesOrdMultierAction",
      getSales: "sales/getSalesAction",
      getFactorys: "factory/getFactorysAction",
      getVehicleList: "vehicle/getVehicleListAction",
      updateSalesOrder: "salesOrder/updateSalesOrderAction",
      getSalesById: "sales/getSalesByIdAction",
      getRecipeSales: "recipeSales/getRecipeSalesAction",
      // getCustomerSimpleList: "customer/getCustomerSimpleListAction",
      getRecommendSalesOrder: "salesOrder/getRecommendSalesOrder",
    }),
    async searchSalesFunc(query) {
      this.searchSales = query;
      this.salesList = [];
      this.isSurplus = true;
      this.salesPage = 0;
      if (this.searchSales !== "") {
        this.customerLoading = true;
        await this.getSalesMethod(this.searchSales);
        this.customerLoading = false;
      }
    },
    async selectSales(sales) {
      const soObject = {
        volPlan: sales.volPlan || 15,
        sales: sales,
      };
      if (sales.prodRecipe) soObject.recipe = sales.prodRecipe;
      this.soList.push(soObject);
    },
    async loadMore() {
      if (this.isSurplus) {
        this.salesPage += 1;
        await this.getSalesMethod(this.searchSales);
      }
    },
    async loadRecipe(page) {
      if (!this.selectItem.sales) {
        console.log('no this.selectItem.sales');
        return;
      }
      if (page)
        this.page = page - 1;
      let api = {
        skip: this.page * 15,
        limit: 15,
        sales: this.selectItem.sales._id,
      };
      if (this.searchRecipeText)
        api.cus_name = this.searchRecipeText;
      try {
        this.tableLoading = true;
        await this.getRecipeSales(api);
        this.tableLoading = false;
      }
      catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    // 点击recipe选择
    async openChooseRecipe(type, item, index) {
      switch (type) {
        case "create":
          if (item.sales) {
            this.selectItem = item;
            this.selectItemIndex = index;
            this.isShowchooseRecipeModal = true;
            await this.loadRecipe();
          }
          break;
        case "edit":
          break;
      }
    },
    async getRecommendSalesOrderMethod() {
      const conditions = {
        skip: this.salesPage * 20,
        limit: this.salesLimit,
        searchText: this.searchText
      };
      try {
        const res = await this.getRecommendSalesOrder(conditions);
        this.soRecommendList = res.salesList;
      }
      catch (error) {
        this.$Message.error('加载销售项目错误');
      }
    },
    async getSalesMethod(cus_name) {
      let api = {
        skip: this.salesPage * 20,
        limit: this.salesLimit,
        cus_name
      };
      const data = await this.getSales(api);
      if (data.salesList.length > 0) {
        this.salesList.push(...data.salesList);
      }
      else if (data.salesList.length === 0) {
        this.salesList.push({ abbr: '已经到底了', _id: dayjs() + 'down', customer: { name: '~~~' }, disable: true });
        this.isSurplus = false;
      }
    },
    chooseRecipe(e) {
      this.soList[this.selectItemIndex].recipe = e;
      this.isShowchooseRecipeModal = false;
    },
    async openDrawer(factory, salesOrder, order, salesProd) {
      this.salesProd = salesProd;
      this.isSurplus = true;
      this.salesList = [];
      if (order) {
        this.editMode = true;
      }
      else {
        this.editMode = false;
      }
      this.searchText = null;
      this.$refs["formItem"].resetFields();
      if (factory) {
        this.formItem.factory = factory.factory._id;
      }
      this.openedSalesOrder = salesOrder;
      if (salesOrder) {
        await this.getSales({ _id: this.formItem.sales });
        this.formItem.sales = salesOrder.sales._id;
        this.formItem.volPlan = salesOrder.volPlan;
        this.formItem.remark = salesOrder.remark;
        this.formItem.arrivedAtDate = salesOrder.planArrivedAt;
        this.formItem.arrivedAtTime = dayjs(salesOrder.planArrivedAt).format("HH:mm");
      }
      else {
        this.soList = [];
        // this.soList.push({
        //   id: dayjs().format(),
        //   volPlan: null,
        //   sales: null,
        //   recipe: null,
        // });
        this.formItem.delivery = { driver: null, vehicle: null };
        // 创建时默认为今天
        this.formItem.arrivedAtDate = new Date();
      }
      this.drawerOpened = true;
      if (!this.editMode) {
        this.getRecommendSalesOrderMethod();
      }
    },
    timeClick(value) {
      this.formItem.arrivedAtTime = value.time;
    },
    dateClick(addDates) {
      this.formItem.arrivedAtDate = dayjs()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .add(addDates, "d")
        .toDate();
    },
    vehicleClick(data, type) {
      switch (type) {
        case "vehicle":
          this.formItem.delivery.vehicle = data._id;
          break;
        case "driver":
          this.formItem.delivery.driver = data._id;
          break;
      }
    },
    tonClick(value, soIndex) {
      this.soList[soIndex].volPlan = value;
    },
    // 删除拼车项目
    delSOList(index) {
      this.soList.splice(index, 1);
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            const uploadData = omit(this.formItem, ['arrivedAtTime', 'arrivedAtDate']);
            uploadData.planArrivedAt = dayjs(this.formItem.arrivedAtDate)
              .hour(parseInt(this.formItem.arrivedAtTime.substring(0, 2)))
              .minute(parseInt(this.formItem.arrivedAtTime.substring(3, 5)));
            if (this.openedSalesOrder) {
              await this.updateSalesOrder({
                id: this.openedSalesOrder._id,
                data: uploadData,
                type: this.salesProd ? "salesProd" : null,
              });
              this.$emit("editSalesProd");
            }
            else {
              uploadData.soList = this.soList.map(v => {
                return { sales: v.sales._id, recipe: v.recipe._id, volPlan: v.volPlan }
              });
              await this.createSalesOrdMultier(uploadData);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          }
          catch (error) {
            this.$Message.error({
              content: "计算失败，" + error,
              closable: true,
              duration: 0,
            });
          }
        }
        else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
  async mounted() {
    this.getFactorys({});
  },
  components: { Divider }
};
</script>

<style scoped lang="stylus">
.search-content-header
  display flex
  justify-content space-between
  align-items center
  padding-left 15px
  margin 20px 0 20px

.customer-cell
  font-weight 400
  font-size 16px
  width 100%
  padding 8px
  margin 10px 0
  cursor pointer
  border 1px solid #fff

  &:hover
    color #0168FA
    border 1px solid #0168FA
    border-radius 4px
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

.tool-btn
  cursor pointer
  color blue
  padding 0 4px
  height 35px
  line-height 35px

.option-cell-list
  display flex
  flex-wrap wrap
  align-content flex-start
  height 100%
  overflow-y auto
  margin-top 16px

.vehicle-cell-list
  display flex
  flex-wrap wrap
  align-content flex-start
  overflow-y auto

.option-cell, .vehicle-option-cell
  font-size 12px
  font-weight 500
  padding 0 8px
  width 50px
  margin 0px 8px 8px 0
  border 1px solid #E2E5ED
  border-radius 4px
  cursor pointer

  &:hover
    color #0168FA
    border 1px solid #0168FA
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

.vehicle-option-cell
  width 90px
  text-align center
  height 35px
  line-height 35px

.selected
  color #0168FA
  border 1px solid #0168FA
  box-shadow 0 2px 4px rgba(209, 230, 250, 1)
  transition 0.2s

h2.sales-title
  margin-bottom 20px

.form-item-wrap
  display flex
  margin-bottom 90px
  height 100%

.form-item-left
  margin-right 20px
  overflow-y auto
  padding 0 16px 200px 0
.form-item-right
  margin-bottom: 65px
  overflow-y auto
  padding 0 16px 200px 0
.sales-order-box
  padding 8px
  border 1px solid #DCDEE2
  border-radius 6px
  margin-top 20px

.addSoList-button
  margin-top 20px

.del-icon
  position relative
  float right
  cursor pointer

.so-recipe-row
  display flex
  align-items center
  margin 8px 0
  cursor pointer

.recipe
  color #42b983

.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between

.footer
    position fixed
    bottom 0px
    width 100%
    height 64px
    background-color #f2f6fa
    display flex
    flex-direction column
    justify-content center
    transition 0.2s
    z-index 1

.sales-row
  padding 2px 0
  cursor pointer
  user-select none
  &:hover
    color #0168FA
</style>
